// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZGVj","option":"styles_option__3aWM7","active":"styles_active__1QnII"};